import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import swal from "sweetalert2";
import { FormControl } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ProcessingInstruction } from "../../models/processingInstruction";
import { Observable } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { map, startWith } from "rxjs/operators";
import { UserService } from "../../services/user.service";
import { ProcessingpService } from "../../services/processing.service";
import { POService } from "../../services/po.service";
import { ImageService } from "../../services/image.service";
import { CitaService } from "../../services/cita.service";
import { TransportationService } from "../../services/transportation.service";
import { LogManifestService } from "../../services/logmanifest.service";
import { LogManifest } from "../../models/logManifest";
import { FileService } from "../../services/file.service";
import { LocationService } from "../../services/location.service";
import { PurchaseTermService } from "../../services/purchaseterms.service";
import { GuiGuard } from "../../shared/guard/base-gui-guard";
import { Methods } from "../../shared/methods";
import { WeightItem } from "../../models/weightitem";
import { WeightItemService } from "../../services/weightitem.service";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { ChatLogService } from "../../services/chatlog.service";
import { ChatLog } from "../../models/chatLog";
import { PurchaseService } from "../../services/purchase.service";
import { ReminderService } from "../../services/reminder.service";
import { Reminder } from "../../models/reminder";
import { ContactsFormService } from "../../services/contactsform.service";
import { ReportService } from "../../services/report.service";
import { ConfigService } from "../../services/config.service";
import { MultiFilesService } from "../../services/multifiles.service";
import { ErasuremethodService } from "../../services/erasuremethod.service";
import { Icon } from "../../models/card-icon";
import { MaterialModule } from "../../app.module";
import { TransportationDetailsComponent } from "../../shared/components/transportation-details/transportation-details.component";

declare const $: any;

export interface UserList {
  value: string;
  name: string;
  promiseDate: string;
  vendor: string;
}
export interface TemplateList {
  value: string;
  name: string;
}

declare interface option {
  colName: string;
  position: number;
  visibility: boolean;
  origin: number;
}

@Component({
  selector: "app-create-pi",
  templateUrl: "./create-pi.component.html",
  styleUrls: ["./create-pi.component.css"],
  providers: [
    GuiGuard,
    CitaService,
    ImageService,
    WeightItemService,
    LogManifestService,
    FileService,
    TransportationService,
    ProcessingpService,
    LocationService,
    ChatLogService,
    ReminderService,
    ContactsFormService,
    ReportService,
    MaterialModule,
    PurchaseTermService,
  ],
})
export class CreatePiComponent implements OnInit {
  @ViewChild(TransportationDetailsComponent)
  child: TransportationDetailsComponent;
  public mtds: Methods = new Methods();
  iconTitle: Icon = {
    icon: "account_tree",
    title: "Add New Processing Instructions",
  };
  public step_pi = 1;
  public template = "";
  public repeatedTemplate = "";
  public templateType = "";
  public form = null;
  public showTemplate = false;
  public listTemplates = null;
  public nameTemplate = "";
  public selectedTemplate = {};
  public vendor_po = "";
  public netTerms: any = [];
  public yesdetail: boolean = false;
  public nodetail: boolean = false;

  public companyLinked = null;
  public titleModal = "PO Details";
  @Input() action: string;
  @Input() id: string = null;
  @Input() poId: number = null;
  @Input() repId: number = null;
  @Input() poNumber = "";
  @Input() frompo = "No";
  @Input() logs: boolean = false;
  @Output() close: EventEmitter<any>;

  @Output() delete_id: EventEmitter<number>;

  public syncdone: boolean = false;
  public syncPOPending: boolean = false;
  public identity;
  public editar = false;
  public createPO = false;
  public internal_id = null;
  public showPopLabel = false;
  public loadingSync = false;
  public loadingTemplates = false;
  public changeStatus = false;
  public nuevoStatus = "";

  public erasureMethods = [];

  public tableTrakings: string[][] = [];

  public asignar = "";
  public sales = "";
  public tech = "";
  public manifest = "";
  public set_id = "";

  public step = "INTRANSIT";
  public image = "local_shipping";
  public progressBar = 12.5;
  public guardando: boolean;
  public cargando: boolean;
  public cargandoBatch: boolean;
  public syncpos: boolean = false;
  public syncposinv: boolean = false;
  public token;
  public repsList: any[] = [];
  public salesList: any[] = [];
  public techList: any[] = [];
  public manifestList: any[] = [];
  public poList: any[] = [];
  public filesCita;
  public citaID: number = null;
  public itemtype;
  public totalNetWeight;
  public itemsweights: Array<WeightItem>;
  public damages;
  public itemIsPi;
  public chats: Array<LogManifest> = [];
  public chatsWeights: Array<ChatLog>;
  public errorContainers: boolean = false;
  public errorHardDrives: boolean = false;
  public errorAllInOne: boolean = false;
  public errorLaptops: boolean = false;
  public errorDesktops: boolean = false;

  public containersProcessed: number = 0;

  public showWarehouseError: boolean = false;

  public trakingNumber = "";
  public expectedDate = "";
  public trakingcomments = "";

  public buscandoTrakings = false;
  public newchatmsg;
  public newchatmsgWeight;
  public jsonChatLog;
  public loading: boolean = false;
  public loading2: boolean = false;
  public respuestapo: any = "";

  public manifestRep: any = "";
  public testingStatusForm: any = "";
  public testingStatus: any = "";

  public createSecondStage: boolean = false;

  public item: ProcessingInstruction;

  public totalWeight = 0;
  public comments = "";
  public privilegio;
  public folderId = "";
  public listaReportes = [];
  pobuscador: UserList; // Valor seleccionado
  public typeofe = "";

  public warehouseList = [];
  public whs_id = null;
  public locationsList = [];
  public location_id = null;
  public loadingLocations = false;

  public ispending = 0;

  public editId = null;

  public buscando = false;
  public loadingPo = false;

  //SECCIÓN REMINDERS
  public idcontact;
  public statusLead;
  public contacthistory: Reminder;
  public status_contactHistory;
  //Usuarios Reminders
  filteredArrayUsers: Observable<UserList[]>;
  myControlUsers = new FormControl();
  public usersSeleccionados = [];
  public arrayUsers: any[] = [];

  //public userinterno;
  public editHistory = false;
  public saveEditHistory = false;
  public options: Array<option> = [];

  public paymentStatus = "";

  filteredClientes: Observable<UserList[]>;
  filteredTemplates: Observable<TemplateList[]>;
  clientes: UserList[] = [];
  templates: TemplateList[] = [];

  myControlClientes = new FormControl();
  myControlTemplates = new FormControl();

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );

  public numberNotifications;
  public notificationsData;
  public userlogged;
  public apiCompany;

  public warehouseActivate: boolean = false;
  public destructionManuallySerialNumber = "";
  public destructionManuallyMake = "";
  public destructionManuallyModel = "";
  public destructionManuallySerialCapacity = "";
  public cerrado = false;
  public reportSaved = 0;
  public poSelectedDestruction;
  public currentReport = 0;
  public destructionpo: string = "";
  public desbloquearpo = false;
  public destructionposelected: string = "";
  public responseDestructionReport: any[] = [];
  public summaryTotal = {};
  public destructionManuallyDate = "";
  public destructionclientsname: string = "";
  public saveunlock = false;

  public apikey = "";

  public idChat;
  public itemChat;
  public typeChat;

  public numNotes = 0;
  public numFiles = 0;
  public selectedPoOption = false;
  public templateId = 0;
  private _filterClientes(name: string): UserList[] {
    const filterValue = name;
    return this.clientes.filter((option) => {
      let selected = String(option.name).toLowerCase().includes(filterValue);
      this.selectedPoOption = selected;
      return selected;
    });
  }
  private _filterUsers(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.arrayUsers.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  private _filterTemplates(name: string): TemplateList[] {
    const filterValue = name;

    return this.templates.filter((option) =>
      String(option.name).toLowerCase().includes(filterValue)
    );
  }
  constructor(
    public guard: GuiGuard,
    private _router: Router,
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _processingSerice: ProcessingpService,
    private _imageService: ImageService,
    private _citaService: CitaService,
    private _poService: POService,
    private _logManifestService: LogManifestService,
    private _fileService: FileService,
    private _transpSservice: TransportationService,
    private _weightItemService: WeightItemService,
    private _locationService: LocationService,
    private _chatLogService: ChatLogService,
    private _purchaseService: PurchaseService,
    public dialog: MatDialog,
    private _reminderService: ReminderService,
    private _ContactFormService: ContactsFormService,
    private _reportService: ReportService,
    private uploadService: MultiFilesService,
    private _erasureService: ErasuremethodService,
    private _configTable: ConfigService,
    private _termService: PurchaseTermService
  ) {
    this.identity = this._userService.getIdentity();
    this.pobuscador = null;
    this.template = "";
    this.guardando = false;
    this.cargando = false;
    this.cargandoBatch = false;
    this.close = new EventEmitter();
    this.delete_id = new EventEmitter();
    this.token = this._userService.getToken();
    this.item = new ProcessingInstruction(this.identity.sub);
    //this.getCatalogos();
    this.apikey = this.identity.apiCompany;

    this._userService.getAllUsersType(this.token, "VENDOR").subscribe(
      (response) => {
        // console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          this.loading = false;
          // this.pacientes2 = response.data;

          response.data.forEach(
            function (element) {
              //  console.log(element);
              if (element.companyLinked === null) {
              } else {
                this.clientes2.push({
                  value: element.id,
                  name:
                    element.name +
                    " " +
                    element.surname +
                    " # " +
                    element.id +
                    " - " +
                    element.companyLinked.name,
                });
              }
            }.bind(this)
          );
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
      }
    );

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    // console.log("privilegio");
    // console.log(this.privilegio);

    if (this.token) {
      this.getNetTerms();
      // console.log("entramos crud");
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          // console.log(response);
          if (response.status == "success") {
            this.userlogged = response.data;

            this.companyLinked = response.data.companyLinked;
            this.apiCompany = this.userlogged.companyLinked.apiToken;
            if (this.userlogged.location == null) {
              this.userlogged.location = {};
              this.userlogged.location.id = 0;
            }

            this.whs_id = this.userlogged.location.id;
            if (this.userlogged.internalLocation !== null)
              this.location_id = this.userlogged.internalLocation.id;
            // console.log(this.internal_id);
            this.location_id = this.internal_id;

            if (this.whs_id > 0) {
              this.warehouseActivate = false;
            } else {
              this.warehouseActivate = true;
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }

    this._erasureService.showAll().subscribe((response) => {
      // console.log(response);
      this.erasureMethods = response.data;
    });

    this.getUsers();
  }

  sync() {
    this.syncpos = true;
    this._processingSerice.sync().subscribe(
      (response) => {
        console.log(response);
        if (response.code === 200) {
          this.getCatalogos();
          this.syncpos = false;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  get isDisabled() {
    return (
      (this.step_pi == 3 &&
        (!this.selectedTerm ||
          (!this.item.originalTotalCostPo &&
            this.item.originalTotalCostPo !== 0) ||
          !this.item.inventoryManifest ||
          !this.item.esgReportingRequired ||
          !this.item.hasTheEquipmentBeenSold ||
          !this.item.buyer.id ||
          !this.item.warranty ||
          !this.item.typeReport)) ||
      (this.step_pi == 4 &&
        (!this.item.all_cod ||
          !this.item.sortEquipment ||
          this.item.pictureRequired < 0 ||
          !this.item.securitySealPictureRequired ||
          !this.item.sendStraightToTesting)) ||
      (this.step_pi == 5 &&
        (!this.item.dataDestructionRequired ||
          !this.item.manifestRequired ||
          (this.yesdetail && !this.item.manifest_priority_level) ||
          (this.nodetail && !this.item.no_manifest_priority_level) ||
          !this.item.pullHardDrives ||
          !this.item.hdShredding ||
          !this.item.holdDefectiveEquipment)) ||
      (this.step_pi == 6 &&
        (!this.item.testingReportRequired ||
          !this.item.poPriorityLevel ||
          !this.item.sortAndSettle)) ||
      (this.step_pi == 7 &&
        (!this.item.passDataErasure1 || !this.item.holdBadHardDrives))
    );
  }

  get manifestReq() {
    if (this.yesdetail == true) {
      return this.item.manifest_priority_level;
    } else if (this.nodetail == true) {
      return this.item.no_manifest_priority_level;
    }
  }
  closeModalAndRemoveTracking(form) {
    this.end(form, true);
    if (this.child) {
      this.child.removeTracking();
    }
    // this.closeModal()
    this.listTemplates = null;
    this.initValues();
    this.sync();
  }
  closeModal() {
    this.listTemplates = null;
  }

  initValues() {
    this.showTemplate = false;
    this.item.all_cod = "";
    //this.selectedTerm = "";
    this.selectedTemplate = "none";
    this.step_pi = 1;
    this.item.id = null;
    this.item.cvCode = "";
    this.item.freightCarrier = "";
    this.item.smallParcelCarrier = "";
    this.item.trackingNumber = "";
    this.item.pullHardDrives = "";
    this.item.manifest = "";
    this.item.passDataErasure1 = "";
    this.item.passDataErasure3 = "";
    this.item.hdShredding = "";
    this.item.hdShreddingWithReport = "";
    this.item.holdBadHardDrives = "";
    this.item.sendStraightToTesting = "";
    this.item.cod = "";
    this.item.specialNotes = "";
    //this.item.netTerms = "";
    this.item.poPriorityLevel = "";
    this.item.warranty = "";
    this.item.originalTotalCostPo = null;
    this.item.companyName = "";
    this.item.contactName = "";
    this.item.phoneNumber = "";
    this.item.email = "";
    this.item.address = "";
    this.item.city = "";
    this.item.state = "";
    this.item.zip = "";
    this.item.manifestRequired = "";
    this.item.dataDestructionRequired = "";
    this.item.holdDefectiveEquipment = "";
    this.item.sortAndSettle = "";
    this.item.inventoryManifest = "";
    this.item.manifest_priority_level = "";
    this.item.expectedDate = "";
    this.item.damages = "";
    this.item.totalNetWeight = 0;
    this.item.shipmentQuantity = 0;
    this.item.net_terms = "";
    this.item.description_techs = "";
    this.item.manifestStatus = "";
    this.item.no_manifest_priority_level = "";
    this.item.isPaid = "";
    this.item.clientName = "";
    this.item.pictureRequired = null;
    this.item.saveAsTemplate = false;
    this.item.templateName = "";
    this.item.proNumber = 0;
    this.item.equipmentComingToWarehouse = "Yes";
    this.item.esgReportingRequired = "";
    this.item.sortEquipment = "";
    this.item.securitySealPictureRequired = "";
    this.item.notesForReceiving = "";
    this.item.notesForManifest = "";
    this.item.testingReportRequired = "";
    this.item.notesForWiping = "";
    this.item.notesForSales = "";
    this.item.typeReport = "";
    this.item.hasTheEquipmentBeenSold = "";
    // this.repId = null;
  }
  findRepById(rep_id: number): any | undefined {
    return this.repsList.find((rep) => rep.rep_id === rep_id);
  }
  selectTemplates(template, event) {
    console.log(template, "this is my template");
    console.log(this.selectedTerm);
    console.log(template.data);
    if (this.selectedTemplate == "none") {
      this.initValues();
    } else {
      if (template.data) {
        this.templateId = template.id;
        this.templateType = template.type;
        this.item.templateName = template.name;
        const obj = JSON.parse(template.data);
        this.item.cvCode = obj.cvCode;
        // this.item.buyer.id = this.repId ? this.repId : null;
        this.item.freightCarrier = obj.freightCarrier;
        this.item.smallParcelCarrier = obj.smallParcelCarrier;
        this.item.trackingNumber = obj.trackingNumber;
        this.item.pullHardDrives = obj.pullHardDrives;
        this.item.manifest = obj.manifest;
        this.item.passDataErasure1 = obj.passDataErasure1;
        this.item.passDataErasure3 = obj.passDataErasure3;
        this.item.hdShredding = obj.hdShredding;
        this.item.hdShreddingWithReport = obj.hdShreddingWithReport;
        this.item.holdBadHardDrives = obj.holdBadHardDrives;
        this.item.sendStraightToTesting = obj.sendStraightToTesting;
        this.item.all_cod = obj.all_cod;
        this.item.specialNotes = obj.specialNotes;
        this.item.poPriorityLevel = obj.po_priority_level;
        this.item.warranty = obj.warranty;
        this.item.originalTotalCostPo = obj.original_total_cost_po;
        this.item.companyName = obj.companyName;
        this.item.contactName = obj.contactName;
        this.item.phoneNumber = obj.phoneNumber;
        this.item.email = obj.email;
        this.item.address = obj.address;
        this.item.city = obj.city;
        this.item.state = obj.state;
        this.item.zip = obj.zip;
        this.item.manifestRequired = obj.manifestRequired;
        this.item.dataDestructionRequired = obj.dataDestructionRequired;
        this.item.holdDefectiveEquipment = obj.hold_defective_equipment;
        this.item.sortAndSettle = obj.sortAndSettle;
        this.item.inventoryManifest = obj.inventory_manifest;
        this.item.manifest_priority_level = obj.manifest_priority_level;
        this.item.expectedDate = obj.expectedDate;
        this.item.damages = obj.damages;
        this.item.totalNetWeight = obj.totalNetWeight;
        this.item.shipmentQuantity = obj.shipmentQuantity;
        this.item.netTerms = obj.net_terms;
        this.selectedTerm = obj.net_terms;
        this.item.description_techs = obj.description_techs;
        this.item.manifestStatus = obj.manifestStatus;
        this.item.no_manifest_priority_level = obj.no_manifest_priority_level;
        this.item.isPaid = obj.isPaid;
        this.item.clientName = obj.clientName;
        this.item.pictureRequired = obj.pictureRequired;
        this.item.proNumber = obj.proNumber;
        (this.item.equipmentComingToWarehouse = obj.equipmentComingToWarehouse),
          (this.item.esgReportingRequired = obj.esgReportingRequired),
          (this.item.sortEquipment = obj.sortEquipment),
          (this.item.sortAndSettle = obj.sort_and_settle),
          (this.item.securitySealPictureRequired =
            obj.securitySealPictureRequired),
          (this.item.notesForReceiving = obj.notesForReceiving),
          (this.item.notesForManifest = obj.notesForManifest),
          (this.item.testingReportRequired = obj.testingReportRequired),
          (this.item.notesForWiping = obj.notesForWiping);
        this.item.notesForSales = obj.notesForSales;
        this.item.typeReport = obj.typeReport;
        this.item.hasTheEquipmentBeenSold = obj.hasTheEquipmentBeenSold;
        // "smallParcelCarrier":"","trackingNumber":""
        this.getNetTerms();
      }
    }
  }

  removeTemplate(id) {
    this._poService.removeTemplate(this.token, id).subscribe(
      (response) => {
        if (response.status === "success") {
        }
        // this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        // this.loadingFalse(indice--);
      }
    );
  }
  valueF = new FormControl();
  terms = new FormControl("");

  delete(event: any, template: any) {
    event.preventDefault();
    event.stopPropagation();
    this.removeTemplate(template.id);
    this.listTemplates = this.listTemplates.filter((x) => x != template);
    if (this.valueF.value == template) this.valueF.setValue(null);
  }
  changeStep(action) {
    if (action == "next" && this.step_pi <= 8) {
      this.step_pi = this.step_pi + 1;
    } else if (action == "previous") {
      this.step_pi = this.step_pi - 1;
    }
    this.changeTitle();
  }
  getNetTerms() {
    this._termService.getTerms(this.token).subscribe((response) => {
      this.netTerms = response.data;

      //console.log(this.selectedTerm);
      //console.log(this.item);
      //console.log(this.selectedTemplate);

      // if(this.listTemplates){

      let item;

      if (Object.keys(this.selectedTemplate).length === 0) 
        item = this.netTerms.find((item) => item.id == this.selectedTerm.id);
      else
        item = this.netTerms.find((item) => item.id == this.selectedTerm);
      
      if (item && item.isRevenueShare) this.isRevenue = item.isRevenueShare;
      
      this.selectedTerm = item;
      console.log(this.selectedTerm);
      // }
    });
  }
  changeTitle() {
    switch (this.step_pi) {
      case 1:
        this.iconTitle.title = "Add New Processing Instructions";
        this.iconTitle.icon = "account_tree";
        break;
      case 2:
        this.iconTitle.title = "Transportation Details";
        this.iconTitle.icon = "directions_bus";
        break;
      case 3:
        this.iconTitle.title = "PO Details";
        this.iconTitle.icon = "assignment";
        break;
      case 4:
        this.iconTitle.title = "Receiving Processing Instructions";
        this.iconTitle.icon = "assignment_returned";
        break;
      case 5:
        this.iconTitle.title = "Manifest Processing Instructions";
        this.iconTitle.icon = "view_list";
        break;
      case 6:
        this.iconTitle.title = "Testing Processing Instructions";
        this.iconTitle.icon = "grading";
        break;
      case 7:
        this.iconTitle.title = "Data Sanitization Processing Instructions";
        this.iconTitle.icon = "grading";
        break;
      case 8:
        this.iconTitle.title = "Sales Processing Instructions";
        this.iconTitle.icon = "account_tree";
        break;
      case 9:
        this.iconTitle.title = "Files";
        this.iconTitle.icon = "file";
        break;

      default:
        this.iconTitle.title = "Add New Processing Instructions";
        this.iconTitle.icon = "account_tree";
        break;
    }
  }

  public clientSelected = "";
  myControlClientes2 = new FormControl();
  filteredClientes2: Observable<UserList[]>;
  public userinterno;
  public creatingpo = false;
  public typeReport = "PHYSICALDESTRUCTION";

  deleteModal() {
    $(".modal-delete").show();
  }
  closeDeleteModal() {
    $(".modal-delete").hide();
  }

  getTrakings() {
    this.tableTrakings = [];
    this.buscandoTrakings = true;

    this._transpSservice.showAll(this.item.po.id).subscribe((response) => {
      // console.log('Traking service:');
      // console.log(response);

      response.data.forEach(
        function (element) {
          this.tableTrakings.push([
            element.id,
            element.trackingNumber,
            this.getFecha(new Date(element.expectedDate.timestamp * 1000)),
            element.comments,
          ]);
        }.bind(this)
      );
      this.buscandoTrakings = false;
    });
  }

  getCita() {
    this._citaService
      .getListByPO(this.token, this.item.po.id)
      .subscribe((r) => {
        if (r.status === "success" && r.data) {
          //console.log("getListByPO response => ", r);
          const response = r.data;
          // this.item.buyer.id = this.identity.sub;
          if (r.po_info && r.po_info.rep && r.po_info.rep.id) {
            console.log("reeeeep", r.po_info.rep.id);
            //console.log(r.po_info.rep.id);
            this.item.buyer.id = r.po_info.rep.id;
            //console.log(this.item.buyer.id);
          }

          if (r.po_info && r.po_info.purchasingterm && r.po_info.purchasingterm.id) {
            this.selectedTerm = r.po_info.purchasingterm;
            this.item.net_terms = r.po_info.purchasingterm;
            //console.log(this.selectedTerm);
          }

          if (r.po_info && r.po_info.erasuremethod) {
            this.item.passDataErasure1 = r.po_info.erasuremethod;
          }

          this.item.pullHardDrives = response.pullHardDrives;
          this.item.manifest = response.manifestRequired;
          //this.item.passDataErasure1 = response.passDataErasure1;
          this.item.passDataErasure3 = response.passDataErasure3;
          this.item.hdShredding = response.hdShredding;
          this.item.hdShreddingWithReport = response.hdShreddingWithReport;
          this.item.holdBadHardDrives = response.holdBadHardDrives;
          this.item.sendStraightToTesting = response.sendStraightToTesting;
          this.item.all_cod = response.allCod;
          this.item.poPriorityLevel = response.poPriorityLevel;
          this.item.warranty = response.warranty;
          this.item.originalTotalCostPo = response.originalTotalCostPo;
          this.item.holdDefectiveEquipment = response.holdDefectiveEquipment;
          this.item.inventoryManifest = response.inventoryManifest;
          this.item.manifest_priority_level = response.manifestPriorityLevel;
          this.item.dataDestructionRequired = response.dataDestructionRequired;
          /*this.item.net_terms = response.netTerms;
          this.selectedTerm = response.netTerms;*/
          this.item.description_techs = response.descriptionTechs;
          this.item.no_manifest_priority_level =
            response.noManifestPriorityLevel;
          this.item.pictureRequired = response.pictureRequired;
          (this.item.esgReportingRequired = response.esgReportingRequired),
            (this.item.sortEquipment = response.sortEquipment),
            (this.item.sortAndSettle = response.sortAndSettle),
            (this.item.securitySealPictureRequired =
              response.securitySealPictureRequired),
            (this.item.notesForReceiving = response.notesForReceiving),
            (this.item.notesForManifest = response.notesForManifest),
            (this.item.testingReportRequired = response.testingReportRequired),
            (this.item.notesForWiping = response.notesForWiping);
          this.item.notesForSales = response.notesForSales;
          this.item.typeReport = response.typeReport;
          this.item.hasTheEquipmentBeenSold = response.hasTheEquipmentBeenSold;
          this.getNetTerms();
        }
      });
  }

  OnHumanSelected(option) {
    if (option) {
      this.item.po.name = option.value.name;
      this.item.po.id = option.value.value;
      this.vendor_po = option.value.vendor;
      this.item.expectedDate = option.value.promiseDate;
      this.selectedPoOption = true;
      // console.log(option, "THIS OOPT");
      this.getCita();
    } else {
      // console.log("no hay opt");
    }
    this.loadingTemplates = true;
    this.getTemplates();
  }

  OnHumanSelectedTemplates(option) {
    this.nameTemplate = option.value.name;
  }

  displayFn(user?: UserList): string | undefined {
    return user && user.name ? user.name : "";
  }
  displayFnT(template?: TemplateList): string | undefined {
    return template ? template.name : undefined;
  }

  getTemplates() {
    this._poService.getAllTemplates(this.token, this.vendor_po).subscribe(
      (response) => {
        if (response.status === "success") {
          this.loadingTemplates = false;
          this.loadingPo = false;

          this.listTemplates = response.data;
          console.log(this.listTemplates, "listtemp");
          this.listTemplates.forEach(
            function (element) {
              this.item.all_cod = element.data.all_cod;
              this.item.esgReportingRequired =
                element.data.esgReportingRequired;
              this.item.netTerms = element.data.net_terms;
              this.templates.push({ value: element.id, name: element.name });
            }.bind(this)
          );
        }
        // this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        // this.loadingFalse(indice--);
      }
    );
  }

  getCatalogos() {
    this.cargando = true;
    let indice = 3;
    this.repsList = [];
    this.poList = [];
    this.clientes = [];
    this._userService.getAllUsersType(this.token, "workers").subscribe(
      (response) => {
        if (response.status === "success") {
          // console.log("Obteniendo los reps:");
          // console.log(response);
          this.repsList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "SALESREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.salesList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "TECHREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.techList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "MANIFESTREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.manifestList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._poService.getAllPOsNEWLite(this.token).subscribe(
      (response) => {
        if (response.status === "success") {
          this.poList = response.data;
          response.data.forEach(
            function (element) {
              //  console.log(element);
              this.clientes.push({
                value: element.id,
                name: element.po,
                promiseDate: element.promiseDate,
                vendor: element.vendor,
              });
              if (element.po === this.poNumber) {
                this.pobuscador = element; // Preselecciona el PO
                this.vendor_po = element.vendor; // Asigna el vendor a this.vendor_po
              }
            }.bind(this)
          );
          if (this.poNumber) {
            this.loadingPo = true;
            this.pobuscador = this.clientes.find(
              (cliente) => cliente.name === this.poNumber
            );
            this.getTemplates();
          }
        }

        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterClientes(name) : this.clientes.slice()))
    );

    console.log("this.filteredClientes => ", this.filteredClientes);

    this.filteredTemplates = this.myControlTemplates.valueChanges.pipe(
      startWith<string | TemplateList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterTemplates(name) : this.templates.slice()
      )
    );
  }

  loadingFalse(indice: number) {
    if (indice === 0) {
      this.cargando = false;
    }
  }

  public recived = null;
  public driver = "";
  public type = "";

  public notfound = false;

  clientes2: UserList[] = [];

  private _filterClientes2(name: string): UserList[] {
    const filterValue = name.toLowerCase();
    return this.clientes2.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit() {
    this.getCatalogos();
    if (this.poNumber) {
      this.loadingPo = true;
    }

    this.item.po.id = this.poId;
    this.item.po.name = this.poNumber;
    this.filteredClientes2 = this.myControlClientes2.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterClientes2(name) : this.clientes2.slice()
      )
    );

    this.item = new ProcessingInstruction(this.identity.sub);
    this.item.po.id = this.poId;
    this.getCita();

    this.item.po.name = this.poNumber;
    this.listaReportes = [];
    this.filteredArrayUsers = this.myControlUsers.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterUsers(name) : this.arrayUsers.slice()))
    );
  }

  getUsers() {
    this.arrayUsers = [];
    this._userService
      .getAllUsersLite(this._userService.getToken(), "exceptuser")
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.arrayUsers = response.data;
          } else {
            alert("Error");
          }
        },
        (error) => {
          console.log(<any>error);
          alert("Error");
        }
      );
  }

  showTemplateForm(event: any) {
    console.log(event, "myevent");
    this.showTemplate = !this.showTemplate;
    // $("#templateForm").modal("show");
  }
  saveTemplate() {
    $("#templateForm").modal("hide");
  }
  cancelSaveTemplate() {
    $("#templateModal").modal("hide");
    this.guardando = false;
  }

  save(form) {
    this.form = form;
    // this.item.expectedDate = new Date(this.item.expectedDate);
    switch (this.action) {
      case "create":
        if (this.listTemplates) {
          this.repeatedTemplate = this.listTemplates.find(
            (element) => element.name === this.item.templateName
          );
        }
        if (this.repeatedTemplate && this.item.saveAsTemplate) {
          this.openModalRepeatedTemplate();
        } else {
          this.savePI();
        }

        break;
      case "remove":
        this._processingSerice
          .delete(this.token, this.id)
          .subscribe((response) => {
            if (response.status === "success") {
              this.end(form, true);
              this.showSwal(
                "success",
                "Processing instructions have been removed!"
              );
            } else {
              this.showSwal("error");
            }
            this.guardando = false;
          });
        break;
    }
  }

  get cita() {
    return {
      EndTime: "00:03",
      StartTime: "00:01",
      account: "",
      address: "Lago Nogal Casa 14",
      all_cod: this.item.all_cod,
      city: "zapopan",
      cod: this.item.cod,
      companyName: this.identity.companyInfo,
      company_id: 32,
      contactName: this.identity.name + " " + this.identity.surname,
      customerSignature: "",
      customerSignatureDate: "",
      dataDestructionRequired: this.item.dataDestructionRequired,
      deliverCheck: "No",
      description_techs: this.item.description_techs,
      driver_id: "4",
      email: this.identity.email,
      gondolas: 0,
      greenTekSolutionsAgent: "",
      greenTekSolutionsAgentDate: "",
      gtsRep: "",
      hdShredding: this.item.hdShredding,
      hdShreddingWithReport: this.item.hdShreddingWithReport,
      holdBadHardDrives: this.item.holdBadHardDrives,
      hold_defective_equipment: this.item.holdDefectiveEquipment,
      hora_fin: "00:00",
      id: 1,
      inventory_manifest: this.item.inventoryManifest,
      manifest: this.item.manifest,
      manifestRequired: this.item.manifestRequired,
      manifest_priority_level: this.item.manifest_priority_level,
      no_manifest_priority_level: this.item.no_manifest_priority_level,
      isPaid: this.item.isPaid,
      net_terms: this.item.netTerms,
      numberOfHelpers: 0,
      original_total_cost_po: this.item.originalTotalCostPo,
      pallets: 0,
      passDataErasure1: this.item.passDataErasure1,
      passDataErasure3: this.item.passDataErasure3,
      phone: "",
      pickUpDate: new Date("1969-01-01"),
      pickUpTime: "00:00",
      pickupDescription: "",
      poNumber: "",
      po_id: this.item.po.id,
      po_priority_level: this.item.poPriorityLevel,
      pullHardDrives: this.item.pullHardDrives,
      rep_id: this.item.buyer.id,
      sendStraightToTesting: this.item.sendStraightToTesting,
      shrinkWrap: 0,
      proNumber: this.item.proNumber,
      sort_and_settle: this.item.sortAndSettle,
      state: "JAL",
      straps: "No",
      toolBox: "No",
      truck_id: "8",
      typeCita: "NOPICKUP",
      user_id: this.identity.sub,
      warranty: this.item.warranty,
      zip: "00000",
      frompo: this.frompo,
      pictureRequired: this.item.pictureRequired,
      save_as_a_template: this.repeatedTemplate
        ? false
        : this.item.saveAsTemplate,
      name_template:
        this.repeatedTemplate || this.item.saveAsTemplate == false
          ? ""
          : this.item.templateName,
      equipmentComingToWarehouse: this.item.equipmentComingToWarehouse,
      notesForReceiving: this.item.notesForReceiving,
      notesForManifest: this.item.notesForManifest,
      testingReportRequired: this.item.testingReportRequired,
      notesForWiping: this.item.notesForWiping,
      notesForSales: this.item.notesForSales,
      esgReportingRequired: this.item.esgReportingRequired,
      sortEquipment: this.item.sortEquipment,
      securitySealPictureRequired: this.item.securitySealPictureRequired,
      typeReport: this.item.typeReport,
      hasTheEquipmentBeenSold: this.item.hasTheEquipmentBeenSold,
    };
  }

  savePI() {
    this.guardando = true;
    this._citaService.create(this.token, this.cita).subscribe(
      (responseCita) => {
        this.guardando = true;
        if (responseCita.code === 200) {
          // this.end(this.form, true);
          this.step_pi = 9;
          this.citaID = responseCita.data.id;
          let idPI;
          idPI = responseCita.idpi;
          this.idPi = idPI;
          this.myWebSocket.next({
            notify: "1",
            data: idPI,
            type: "PI",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          let data;
          data = {
            totalNetWeight: this.item.totalNetWeight,
            shipmentQuantity: this.item.shipmentQuantity,
            damages: this.item.damages,
          };

          this._processingSerice
            .weights(this.token, this.citaID, data)
            .subscribe((response) => {
              if (response.status === "success") {
                // this.end(this.form, true);
                this.id = response.data.id;
                this.showToast(
                  "success",
                  "Processing instructions have been saved!",
                  2000
                );
              } else {
                this.showSwal("error");
              }
              this.guardando = false;
            });
          // this.closeModal();
          this.step_pi = 9;
          this.sync();
          // $("#templateModal").modal("hide");

          // window.location.reload();
          // this.getTemplates();
        } else {
          this.guardando = false;
          this.mtds.notifyError(responseCita.msg);
        }
      },
      (error) => {
        this.guardando = false;
        this.mtds.notifyError(error.statusText);
      }
    );
  }
  updateTemplate() {
    const json = {
      name: this.item.templateName,
      data: this.cita,
      type: this.templateType,
    };
    this._poService.updateTemplate(this.token, json, this.templateId).subscribe(
      (response) => {
        if (response.status === "success") {
          $("#templateModal").modal("hide");
        }

        // this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        // this.loadingFalse(indice--);
      }
    );
  }
  saveAndUpdate() {
    this.savePI();
    this.updateTemplate();
  }
  openModalRepeatedTemplate() {
    $("#templateModal").modal("show");
  }

  end(form = null, valor: boolean = false) {
    console.log("entra");
    this.selectedTerm = "";
    this.pobuscador = null;
    // this.tab = 1;
    this.totalWeight = 0;
    this.comments = "";
    this.editar = false;
    if (this.poId === null && form !== null) {
      form.reset();
    }
    this.item.po.id = null;

    this.step = "INTRANSIT";
    this.item = new ProcessingInstruction(this.identity.sub);
    this.item.po.id = this.poId;
    this.item.po.name = this.poNumber;
    this.filesCita = [];
    this.itemsweights = [];
    this.trakingNumber = "";
    this.expectedDate = "";
    this.sales = "";
    this.tech = "";
    this.locationsList = [];
    this.close.emit(valor);
    $("#modal-files").show();
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: "ERROR!",
        text: "An error has ocurred.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio;
    anio = fecha.getFullYear();

    return anio + "-" + month + "-" + day;
  }

  public locktypeofequipment = false;
  public lockitemtype = false;
  public lockdamage = false;
  public term = {};
  public selectedTerm: any;
  public isRevenue = 0;
  public idPi = 0;
  selectTerms(term, e) {
    console.log(term);
    this.item.netTerms = term.id;
    this.isRevenue = term.isRevenueShare;
    term.name == "No Cost"
      ? (this.item.originalTotalCostPo = 0)
      : this.item.originalTotalCostPo;
  }

  selectChange(campo: string, event) {
    switch (campo) {
      case "manifest_priority_level": {
        if (this.item.manifest_priority_level === "NOMANIFEST") {
          this.item.manifest = "No";
          this.item.manifestRequired = "No";
        } else {
          this.item.manifest = "Yes";
          this.item.manifestRequired = "yesDetailedManifest";
          this.item.no_manifest_priority_level = "";
        }
        break;
      }
      case "all_cod": {
        if (this.item.all_cod == "Yes") {
          this.item.cod = "No";
          this.item.hdShredding = "No";
          this.item.hdShreddingWithReport = "No";
          this.item.pullHardDrives = "No";
          this.item.passDataErasure3 = "No";
          this.item.holdBadHardDrives = "No";
          this.item.sendStraightToTesting = "No";

          $("#passDataErasure1").append(`<option value="DESTR"> 
                                      Destruction
                                  </option>`);
          //  this.item.passDataErasure1 = 'DESTR';

          this.item.holdDefectiveEquipment = "nothin";
          this.item.sortAndSettle = "No";
          this.item.inventoryManifest = "nBrea";
          this.item.dataDestructionRequired = "yesDataDestruction";
        }
        break;
      }
      case "cod": {
        break;
      }
      case "hdShredding": {
        if (this.item.hdShredding == "Yes") {
          // this.item.passDataErasure1 = 'No';
          // this.item.passDataErasure3 = 'No';
          this.item.pullHardDrives = "Yes";
          this.item.sendStraightToTesting = "No";
          this.item.hdShreddingWithReport = "No";
          // this.item.holdBadHardDrives = 'No';
          this.item.sendStraightToTesting = "No";
        }
        break;
      }
      case "hdShreddingWithReport": {
        if (this.item.hdShreddingWithReport == "Yes") {
          // this.item.passDataErasure1 = "3X Pass";
          this.item.passDataErasure3 = "No";
          this.item.pullHardDrives = "Yes";
          this.item.sendStraightToTesting = "No";
          this.item.hdShredding = "No";
          this.item.holdBadHardDrives = "No";
        }
        break;
      }
      case "pullHardDrives": {
        if (this.item.pullHardDrives == "Yes") {
          this.item.sendStraightToTesting = "No";
        }
        break;
      }
      case "manifest": {
        if (this.item.manifest == "Yes") {
          this.item.sendStraightToTesting = "No";
        } else if (this.item.manifest == "No") {
          //this.item.no_manifest_priority_level = 'No Manifest - 15 Days';
        }
        break;
      }
      case "passDataErasure1": {
        if (this.item.passDataErasure1 == "Yes") {
          this.item.passDataErasure3 = "No";
        }
        break;
      }
      case "passDataErasure3": {
        if (this.item.passDataErasure3 == "Yes") {
          this.item.passDataErasure1 = "3X Pass";
        }
        break;
      }
      case "holdBadHardDrives": {
        break;
      }
      case "manifestRequired": {
        if (this.item.manifestRequired == "yesDetailedManifest") {
          this.item.no_manifest_priority_level = "";
          this.yesdetail = true;
          this.nodetail = false;
        }
        if (
          this.item.manifestRequired == "noReportingRequired" ||
          this.item.manifestRequired == "noCertificateDisposalOnly"
        ) {
          this.item.manifest_priority_level = "";
          this.nodetail = true;
          this.yesdetail = false;
        }
        break;
      }
      case "sendStraightToTesting": {
        break;
      }
    }
  }

  public tab = 1;

  get title() {
    switch (this.tab) {
      case 1:
        this.titleModal = "PO Details";
        break;
      case 2:
        this.titleModal = "Transportation Details";
        break;
      case 3:
        this.titleModal = "Receiving Processing Instructions";
        break;
      case 4:
        this.titleModal = "Testing Processing Instructions";
        break;
      case 5:
        this.titleModal = "Set Weights";
        break;
      case 6:
        this.titleModal = "Files";
        break;
      case 7:
        this.titleModal = "Notes";
        break;
      case 8:
        this.titleModal = "Tickets";
        break;
      case 9:
        this.titleModal = "Reminders";
        break;
      default:
        this.titleModal = "PO Details";
    }
    return this.titleModal;
  }
}
